export const serviceslinks = [
    {
        name: "Commercial Pest Control",
        path: '/commercial-pest-control',
        cName: 'dropdown-link'
    },
    {
        name: "Residential Pest Control",
        path: '/residential-pest-control',
        cName: 'dropdown-link'
    },
    {
        name: "Fumigation Services",
        path: '/fumigation-services',
        cName: 'dropdown-link'
    },
    {
        name: "Bird Control",
        path: '/bird-control',
        cName: 'dropdown-link'
    },
    {
        name: "Consultancy & Training",
        path: '/consultancy-training',
        cName: 'dropdown-link'
    },
    {
        name: "Sanitation Services",
        path: '/sanitation-services',
        cName: 'dropdown-link'
    }
]


// export const adcartlinks = [
//     // {
//     //     name: "The AdCart Magazine",
//     //     path: '/adcart-magazine',
//     //     cName: 'dropdown-link'
//     // },
//     {
//         name: "The AdCart Downloads",
//         path: '/adcart-downloads',
//         cName: 'dropdown-link'
//     }
// ]


// Home page services section img


const serviceOne = require('../src/images/residential.jpg');
const serviceTwo = require('../src/images/commercial.jpg');


export const homeServices = [
    {
        id: 1,
        title: 'Residential Pest Control',
        description: 'Our team will conduct a thorough inspection of your home to identify the source of the problem and develop a customized solution to eliminate the pests.',
        img: serviceOne,
        path: '/residential-pest-control'
    },
    {
        id: 1,
        title: 'Comercial Pest Control',
        description: 'We offer tailored solutions for businesses, including restaurants, hotels, and warehouses, to ensure that your premises comply with health and safety regulations.',
        img: serviceTwo,
        path: '/commercial-pest-control'
    },

]


// Testimonials section data

export const testimonials = [
    {
        id: 1,
        name: 'Ms. Sharma Jaya',
        description: 'We run a busy warehouse in Nairobi and were struggling with rats and cockroaches. We tried several pest control services before, but none of them seemed to solve the problem. Then we found your company, and they were like magic! They identified the root cause of the infestation and provided a comprehensive solution that worked. Now our warehouse is clean and pest-free. Thank you!',
        // title: 'A Company',
        img: require('../src/images/avatar1.png')
    },
    {
        id: 2,
        name: 'Hannah Chebet',
        description: 'As a luxury hotel in Nairobi, we cant afford to have any pests in our premises. That is why we rely on your pest control service to keep our rooms, restaurants, and public areas clean and hygienic. Your technicians are always prompt, professional, and effective. We have been using your service for years and have never been disappointed.',
        // title: 'B Company',
        img: require('../src/images/avatar1.png')
    },
    {
        id: 3,
        name: 'Yogesh Patel',
        description: 'Living in Nairobi, we have had our fair share of pest problems, from bedbugs to termites. We tried to solve them on our own, but it was a nightmare. Then we decided to call your pest control service, and it was the best decision we have made. Your technicians were friendly, knowledgeable, and thorough. They not only solved our pest problems but also gave us tips on how to prevent them in the future. We are so grateful.',
        // title: 'C Company',
        img: require('../src/images/avatar1.png')
    },
    {
        id: 4,
        name: 'Edward Kimiri',
        description: 'Running a restaurant in Nairobi is tough, and dealing with pests is one of the biggest challenges. We have tried several pest control companies before, but they either charged us too much or did not deliver results. That is why we are so happy we found your service. You are affordable, reliable, and really good at what you do. Our customers have noticed the difference, and we have seen an increase in business as a result. Thanks!',
        // title: 'D Company',
        img: require('../src/images/avatar1.png')
    }
];

// FAQS

export const faqs = [
    {
        id: 1,
        question: "What pests do you specialize in controlling?",
        answer: `At PestEX Masters, we specialize in the control and eradication of a wide range of pests, including but
        not limited to cockroaches, termites, bed bugs, ants, mosquitoes, rats, mice, fleas, and spiders. Our
        experienced technicians are trained to handle various pest infestations with efficiency and effectiveness.`
    },
    {
        id: 2,
        question: "Are your pest control methods safe for my family and pets?",
        answer: `Absolutely! We prioritize the safety of your family, pets, and the environment. PestEX Masters utilizes
        eco-friendly and approved pest control products that are safe for humans and pets. Our team follows
        strict guidelines to ensure that all treatments are applied in a manner that minimizes any potential risks
        to your loved ones.`
    },
    {
        id: 3,
        question: "How long does a typical pest control treatment take?",
        answer: `The duration of a pest control treatment varies depending on the nature and severity of the
        infestation. For common household pest problems, treatments usually take anywhere from 1 to 2 hours.
        However, for more complex cases or larger properties, the timeframe may be longer. Our team will
        provide you with an estimated time frame during the initial inspection.`
    },
    {
        id: 4,
        question: "Do I need to vacate my premises during the pest control treatment?",
        answer: `In most cases, you and your family do not need to leave your premises during the treatment.
        However, we recommend that pregnant women, infants, and individuals with respiratory conditions or
        sensitivities stay away from the treated areas until the products have dried. Our technicians will provide
        you with specific instructions tailored to your situation.`
    },
    {
        id: 5,
        question: "How often should I schedule pest control services?",
        answer: `The frequency of pest control services depends on various factors, such as the pest type, severity of
        the infestation, and your property&#39;s susceptibility to pests. For preventive measures, we recommend
        regular treatments every 3 to 6 months. However, for more severe infestations, our technicians will
        assess the situation and recommend a suitable treatment plan.`
    },
    {
        id: 6,
        question: "Can I book a one-time pest control service or do I need a contract?",
        answer: `At PestEX Masters, we provide both one-time pest control services and long-term contracts tailored
        to your needs. If you have a specific pest problem you&#39;d like to address, you can opt for a single
        treatment. For comprehensive and ongoing pest management, we offer contract options that include
        regular inspections and treatments to ensure your property remains pest-free.`
    },
    {
        id: 7,
        question: "How can I prevent future pest infestations?",
        answer: `Along with our professional pest control services, we believe in empowering our customers with
        preventive measures. Our technicians will provide you with personalized recommendations to help
        prevent future pest infestations. These may include sealing entry points, maintaining cleanliness, storing
        food properly, and implementing appropriate landscaping practices. Regular inspections and proactive
        measures can significantly reduce the risk of pests returning.`
    }
]